export const AllotmentTypes = {
    PTO: 1, // Personal time off
    CARR: 2, // Carry over pto
    CMPPTO: 3, // Compensation time award
    SICK: 4, // Sick days
    SMRNY: 5, // Summer days
    PTOAUTO: 6, // Carry over sick days
    MOVE: 7, // Move
    STUDY: 8, // Study
    GENERALREST: 9999, // Sick, rest, family
    OTHERS: 999, // Other
};

export const ReasonCode = {
    PTO: "PTO",
    FTO: "FTO",
};
